<template>
  <div>
    <b-form @submit="SaveCustomerList">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#1E90FF"
      ></loading>
      <!-- <div class="box box-primary">
            <div class="box-body">
                <button type="button" class="btn btn-primary">Primary</button>
                <button type="button" class="btn btn-default">Primary</button>
                <button type="button" class="btn btn-default">Primary</button>
            </div>
        </div> -->

      <div class="box box-primary">
        <div class="box-header">
          <h3 class="box-title">{{ $t("customer.profile") }}</h3>
        </div>
        <div class="box-body">
          <div style="display:flex; justify-content: space-around">
            <Avatar
              @completed="handleCompleted"
              ref="foo"
              :urlAvatar="customerdata.url_avatar"
            />
            <!-- <div class="col-md-6 col-sm-6 col-6 text-center">
              <span
                :class="
                  reward.name == 'platinum'
                    ? 'platinumstar'
                    : reward.name == 'gold'
                    ? 'goldstar'
                    : reward.name == 'silver'
                    ? 'silverstar'
                    : 'bronzestar'
                "
                >&#9733;</span
              >
              <h3>{{ $t("reward.type") }} {{ reward.type }}</h3>
              <h4 v-if="reward.wanted_point == null">{{ reward.text }}</h4>
              <h4 v-else>{{ reward.text }}</h4>
            </div> -->
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group required">
                <label for="fullname" class="control-label">{{
                  $t("customer.fullname")
                }}</label>
                <input
                  v-model="customerdata.fullname"
                  type="text"
                  class="form-control"
                  id="fullname"
                  :placeholder="$t('customer.fullname')"
                  @input="validateFieldIsEmpty('fullname')"
                />
                <span
                  v-if="this.field_required.fullname != ''"
                  class="help is-danger"
                >
                  <font color="red">{{ $t(field_required.fullname) }}</font>
                </span>
              </div>
            </div>
            <!-- <div class="col-md-4">
              <div class="form-group required">
                <label for="first_name" class="control-label">{{
                  $t("customer.firstname")
                }}</label>
                <input
                  v-model="customerdata.first_name"
                  type="text"
                  class="form-control"
                  id="first_name"
                  :placeholder="$t('customer.firstname')"
                  @input="validateFieldIsEmpty('first_name')"
                />
                <span
                  v-if="this.field_required.first_name != ''"
                  class="help is-danger"
                >
                  <font color="red">{{ $t(field_required.first_name) }}</font>
                </span>
              </div>
            </div> -->
            <div class="col-md-4">
              <div class="form-group required">
                <label for="email" class="control-label">{{
                  $t("customer.email")
                }}</label>
                <input
                  :disabled="customerdata.id > 0"
                  v-model="customerdata.email"
                  type="email"
                  class="form-control"
                  id="email"
                  placeholder="example@example.com"
                  @input="validateEmailAll('email')"
                />
                <span
                  :class="{
                    email_activated: email_activated,
                    show_email: show_email
                  }"
                  class="email_default"
                  >{{ status_active }}</span
                >

                <span
                  v-if="this.field_required.email != ''"
                  class="help is-danger"
                >
                  <font color="red">{{ $t(field_required.email) }}</font>
                </span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="dob">{{ $t("customer.ownedApartment") }}</label>
                <input
                  type="text"
                  :placeholder="$t('apartment.name')"
                  class="form-control"
                  style="text-align: center;"
                  v-model="in_charge_of_apartments"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="dob">{{ $t("customer.dob") }}</label>
                <date-picker
                  class="form-control"
                  v-model="customerdata.dob"
                  :config="options"
                  id="dob"
                ></date-picker>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="phone" class="control-label">{{
                  $t("customer.phone")
                }}</label>
                <input
                  v-model="customerdata.phone"
                  type="text"
                  class="form-control"
                  id="phone"
                  :placeholder="$t('customer.phone')"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label
                  for="identificationnumber"
                  class="control-label"
                  :title="$t('customer.passport_identificationnumber')"
                  >{{ $t("customer.identificationnumber") }}</label
                >
                <b-form-input
                  v-model="customerdata.identificationnumber"
                  type="number"
                  :required="ischeck"
                  class="form-control"
                  id="identificationnumber"
                  :placeholder="$t('customer.identificationnumber')"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label
                  for="passport"
                  class="control-label"
                  :title="$t('customer.passport_identificationnumber')"
                  >{{ $t("customer.passport") }}</label
                >
                <input
                  v-model="customerdata.passport"
                  type="text"
                  class="form-control"
                  id="passport"
                  :placeholder="$t('customer.passport')"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="gender" class="control-label">{{
                  $t("customer.gender")
                }}</label>
                <select v-model="customerdata.gender" class="form-control">
                  <option
                    v-for="gender in gender_list"
                    v-bind:value="gender.id"
                    :key="gender.id"
                    >{{ $t(gender.text) }}</option
                  >
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="groups" class="control-label">{{
                  $t("customer.groups_title.title")
                }}</label>
                <select
                  v-model="customerdata.group"
                  @change="onChangeGroups($event)"
                  class="form-control"
                  id="group"
                >
                  <option value="1">{{ $t("customer.groups[0]") }}</option>
                  <option value="2">{{ $t("customer.groups[1]") }}</option>
                </select>
              </div>
            </div>
            <!-- <div class="col-md-4">
              <div class="form-group">
                <label for="reward_point" class="control-label">{{
                  $t("reward.reward_point")
                }}</label>
                <input
                  type="number"
                  placeholder="Điểm Thưởng"
                  class="form-control"
                  v-model="customerdata.reward_point"
                  min="0"
                  style="text-align:right;"
                />
              </div>
            </div> -->
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="country">{{ $t("customer.country") }}</label>
                <b-form-select
                  :options="country_list"
                  v-model="customerdata.country_code"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="address" class="control-label">{{
                  $t("customer.address")
                }}</label>
                <input
                  v-model="customerdata.address"
                  type="text"
                  class="form-control"
                  id="address"
                  :placeholder="$t('customer.address')"
                />
              </div>
            </div>
            <div
              class="col-md-4"
              v-show="parseInt(this.$route.params.id) == 0 ? false : true"
            >
              <div class="form-group required" v-if="showPasswordText == true">
                <label for="password" class="control-label">{{
                  $t("customer.password")
                }}</label>
                <input
                  v-model="customerdata.password"
                  @input="validatePassword(customerdata.password)"
                  type="password"
                  class="form-control"
                  id="password"
                  :placeholder="$t('customer.password')"
                />
                <span
                  :class="{
                    password_length_count: valid_password_length,
                    show_password_length: password_typed
                  }"
                  class="password_length"
                  >{{ password_length }}</span
                >

                <span
                  v-if="this.field_required.password != ''"
                  class="help is-danger"
                >
                  <font color="red">{{ $t(field_required.password) }}</font>
                </span>

                <div v-show="password_typed" class="lnu_container">
                  <p :class="{ got_lowercase: contain_lowercase }">
                    {{ $t("user.lowercase") }}
                  </p>
                  <p :class="{ got_number: contain_number }">
                    {{ $t("user.digit") }}
                  </p>
                  <p :class="{ got_uppercase: contain_uppercase }">
                    {{ $t("user.uppercase") }}
                  </p>
                </div>
              </div>
              <div class="form-group" v-else>
                <label for="password">{{ $t("customer.password") }}</label>
                <div>
                  <b-button
                    v-if="isCurrentUser"
                    class="form-control"
                    variant="primary"
                    @click="showModal"
                    >{{ $t("customer.password_modal[0].title") }}</b-button
                  >
                  <b-button
                    v-else
                    class="form-control"
                    variant="primary"
                    @click="showConfirmPass"
                    >{{
                      $t("customer.password_modal[0].title_reset")
                    }}</b-button
                  >
                </div>
              </div>
            </div>
            <div class="col-md-4" v-if="false">
              <div class="form-group">
                <label for="cromcode">{{ $t("customer.crmcode") }}</label>
                <input
                  v-model="customerdata.crmcode"
                  type="text"
                  class="form-control"
                  id="cromcode"
                  :placeholder="$t('customer.crmcode')"
                />
              </div>
            </div>
          </div>

          <!-- [loitt] - #1459 THÊM LOẠI KHÁCH HÀNG - TẠO MỚI KH -->
          <div
            class="row"
            v-if="customerdata.group == 2 || customerdata.group == 3"
          >
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <div
                    v-if="customerdata.group == 2"
                    class="form-group required"
                  >
                    <label class="control-label">{{
                      $t("customer.groups_title.mst")
                    }}</label>
                    <input
                      v-model="customerdata.personal_tax_code"
                      type="number"
                      class="form-control"
                      id="personal_tax_code"
                      :required="true"
                      :placeholder="$t('customer.groups_title.mst')"
                    />
                  </div>
                  <div v-else-if="customerdata.group == 3" class="form-group">
                    <label class="control-label">{{
                      $t("customer.groups_title.mst")
                    }}</label>
                    <input
                      v-model="customerdata.personal_tax_code"
                      type="text"
                      class="form-control"
                      id="personal_tax_code"
                      :placeholder="$t('customer.groups_title.mst')"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label">{{
                      $t("customer.groups_title.representative_name")
                    }}</label>
                    <input
                      v-model="customerdata.profile_representative_name"
                      type="text"
                      class="form-control"
                      id="profile_representative_name"
                      :placeholder="
                        $t('customer.groups_title.representative_name')
                      "
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label">{{
                      $t("customer.groups_title.representative_phone")
                    }}</label>
                    <input
                      v-model="customerdata.profile_representative_phone"
                      type="text"
                      class="form-control"
                      id="profile_representative_phone"
                      :placeholder="
                        $t('customer.groups_title.representative_phone')
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- button give point  -->
          <!-- <div class="row">
            <div class="col-md-12">
              <button
                style="margin-bottom: 15px;"
                class="btn btn-success btn-sm extra-tools pull-right"
                @click.prevent="giveRewardPoint"
              >
                <i class="fa fa-star"></i> {{ $t("reward.givePoint") }}
              </button>
            </div>
          </div> -->
          <div class="row">
            <div class="col-md-12" v-show="false">
              <div
                v-show="customerdata.is_company"
                class="row"
                style="margin-top:20px;"
              >
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="company_name">{{
                      $t("customer.company_name")
                    }}</label>
                    <b-form-input
                      type="text"
                      :required="ischeck"
                      class="form-control"
                      v-model="customerdata.company_name"
                      id="company_name"
                      :placeholder="$t('customer.company_name')"
                    />
                  </div>
                </div>
                <!-- /userName -->
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="company_address">{{
                    $t("customer.company_address")
                  }}</label>
                  <b-form-input
                    v-model="customerdata.company_address"
                    type="text"
                    :required="ischeck"
                    class="form-control"
                    id="company_address"
                    :placeholder="$t('customer.company_address')"
                  />
                </div>
                <!-- /crmcode -->
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="company_tax_code">{{
                    $t("customer.company_tax_code")
                  }}</label>
                  <b-form-input
                    v-model="customerdata.company_tax_code"
                    type="number"
                    :required="ischeck"
                    class="form-control"
                    id="company_tax_code"
                    :placeholder="$t('customer.company_tax_code')"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-md-12">
              <div class="inside-section-header">
                <i data-v-2e17af2d="" class="fa fa-user"></i>
                <label>{{ $t(`customer.contacts.title`) }}:</label>
              </div>
              <div class="row">
                <div
                  class="col-md-6"
                  v-for="(item, index) in customerdata.contacts"
                  :data="item"
                  :key="index"
                  :value="item.id"
                >
                  <label v-if="index == 0">{{
                    $t(`customer.contacts.first_label`)
                  }}</label>
                  <label v-else>{{
                    $t(`customer.contacts.second_label`)
                  }}</label>
                  <div class="form-group">
                    <label>{{ $t(`customer.contacts.contact_person`) }}</label>
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('customer.contacts.contact_person')"
                      v-model="item.contact_person"
                    />
                  </div>
                  <div class="form-group">
                    <label>{{
                      $t(`customer.contacts.cell_mobile_phone`)
                    }}</label>
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('customer.contacts.cell_mobile_phone')"
                      v-model="item.cell_mobile_phone"
                    />
                  </div>
                  <div class="form-group">
                    <label>{{ $t(`customer.contacts.email_address`) }}</label>
                    <input
                      type="email"
                      class="form-control"
                      :placeholder="$t('customer.contacts.email_address')"
                      v-model="item.email_address"
                      @input="validate(item.email_address)"
                    />
                  </div>
                  <div class="form-group">
                    <label>{{ $t(`customer.contacts.address`) }}</label>
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('customer.contacts.address')"
                      v-model="item.address"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="onCurrentService"
            v-if="assignShow"
          >
            {{ $t("customer.services") }}
          </button>

          <button
            type="button"
            class="btn btn-primary"
            @click="onOpenServices"
            v-if="assignShow"
          >
            {{ $t("customer.services_history") }}
          </button>
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="CancelCustomerList"
            style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <!-- <button
            type="button"
            v-if="has_perm('print_customer') || GET_ACCOUNT_DATA.id == 1"
            class="btn btn-labeled btn-warning pull-right"
            @click="showPrintPdf"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-print"></i> </span
            >{{ $t("common.printPdf") }}
          </button> -->
          <button
            v-if="
              has_perm('update_customer') ||
                GET_ACCOUNT_DATA.id == 1 ||
                has_perm('create_customer')
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onSave((cont = false))"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.saveclose") }}
          </button>
          <button
            v-if="has_perm('update_customer') || GET_ACCOUNT_DATA.id == 1"
            type="button"
            class="btn btn-labeled btn-default pull-right"
            @click="onSave((cont = true))"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-forward"></i>
            </span>
            {{ $t("common.savecontinue") }}
          </button>
          <!-- Only show with admin -->
          <button
            v-show="
              this.GET_ACCOUNT_DATA.privilege_id == 2 &&
              parseInt(this.$route.params.id) == 0
                ? false
                : true
            "
            type="button"
            v-if="has_perm('update_customer') || GET_ACCOUNT_DATA.id == 1"
            class="btn btn-labeled btn-success pull-right"
            @click="clickOpenModalChangeEmail"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.change_email") }}
          </button>
          <button
            v-show="
              parseInt(this.$route.params.id) == 0 || email_activated
                ? false
                : true
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="doResentActivattionAccount"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("user.resent_activation") }}
          </button>
          <button
            v-show="
              this.GET_ACCOUNT_DATA.id != 1 ||
              email_activated ||
              parseInt(this.$route.params.id) == 0
                ? false
                : true
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="doActivateAccount"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("user.activate_account") }}
          </button>
        </div>
        <b-button
          ref="formsubmitbutton"
          type="submit"
          variant="primary"
          style="display: none;"
          >{{ $t("common.submit") }}</b-button
        >
      </div>
    </b-form>

    <add-customer-into-apartment
      ref="addCustomerIntoApartment"
      :customerData="customerdata"
      :customerId="parseInt(customerdata.id)"
    />
    <!-- <RelativesView
      v-if="!!parseInt(customerdata.id)"
      :id="parseInt(customerdata.id)"
      @relatives_items="relativesItems"
    /> -->

    <!-- <RelatedResidentsView
      v-if="!!parseInt(customerdata.id)"
      :id="parseInt(customerdata.id)"
      @related_residents_items="relatedResidentsItems"
    /> -->

    <!-- <ResidentCards
      v-if="!!parseInt(customerdata.id)"
      :id="parseInt(customerdata.id)"
      @cards="getCards"
    /> -->

    <!-- <RegisterVehicleView
      v-if="!!parseInt(customerdata.id)"
      :id="parseInt(customerdata.id)"
      @vehicles="getVehicles"
    /> -->

    <RegisterOtherInfoView
      v-if="!!parseInt(customerdata.id)"
      :id="parseInt(customerdata.id)"
    />
    <!-- Import file -->
    <div class="box box-primary" v-show="params_id != 0">
      <div class="box-header with-border">
        <h4 class="modal-title">{{ $t("contract.import_title") }}</h4>
        <button
          @click="handleUpload"
          type="button"
          style="float: right"
          class="btn btn-primary"
        >
          <i class="fa fa-upload" aria-hidden="true"></i> Upload Files
        </button>
      </div>
      <form class="form-horizontal">
        <div class="box-body">
          <div class="row mb-1 margin-down-15">
            <div class="col-md-12">
              <div
                v-for="file in file_contract_list"
                :key="file.id"
                class="file-listing"
              >
                <div
                  style="border: solid;display: flex;margin-top:1rem;flex-direction: column;padding: 1rem;"
                >
                  <span class="name-file">
                    <a :href="file.url">
                      <strong>{{ file.name }}</strong>
                    </a>
                    <span
                      style="float:right; cursor: pointer;"
                      class="remove-file"
                      v-on:click.prevent="removeUrl(file.id)"
                    >
                      Remove</span
                    >
                  </span>

                  <div>
                    <span class="name-file">{{ file.date_upload }}</span> -

                    <span class="size-file">{{ readFileSize(file.size) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- End import file -->
    <!-- modal- import -->
    <div class="modal fade" :ref="`modal-import`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ $t("contract.import_title") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="col-md-12 col-sm-12">
                <div
                  v-for="(file, key) in contract_files"
                  :key="file.name"
                  class="file-listing"
                >
                  <div
                    style="border: solid;display: flex;margin-top:1rem;flex-direction: column;padding: 1rem;"
                  >
                    <span class="name-file"
                      ><strong>{{ file.name }}</strong>
                      <span
                        style="float:right; cursor: pointer;"
                        class="remove-file"
                        v-on:click="removeFile(key)"
                      >
                        Remove</span
                      >
                    </span>

                    <div>
                      <span class="name-file">{{ date_uploaded }}</span> -

                      <span class="size-file">{{
                        readFileSize(file.size)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-warning pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              @click="Upload_file()"
              class="btn btn-primary"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- import file -->
    <div style="display:none">
      <input
        type="file"
        id="files"
        name="ImportFile"
        ref="files"
        multiple
        v-on:change="handleFilesUpload()"
        @click="$refs.files.value = null"
      />
    </div>

    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <router-view></router-view>
    <!-- Modal Component -->
    <div class="modal fade" id="modal-newpassword">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h1 class="modal-title">
              {{ $t("customer.password_modal[0].title") }}
            </h1>
            <p style="margin-top: 30px">
              {{ $t("customer.password_modal[0].guide") }}
            </p>
          </div>
          <div class="modal-body">
            <b-form>
              <b-form-group :label="$t('customer.password_modal[0].oldpass')">
                <div class="form-group">
                  <div class="input-group">
                    <b-form-input
                      :type="OldPasswordFieldType"
                      v-model="oldPassword"
                      :placeholder="
                        $t('customer.password_modal[0].enteroldpass')
                      "
                    />
                    <span class="input-group-btn">
                      <button
                        class="btn btn-default"
                        type="button"
                        @click="switchVisibility(1)"
                      >
                        <i :class="iconFieldTypeOldPass" />
                      </button>
                    </span>
                  </div>
                </div>
              </b-form-group>
              <b-form-group :label="$t('customer.password_modal[0].newpass')">
                <div class="form-group">
                  <div class="input-group">
                    <b-form-input
                      :type="NewPasswordFieldType"
                      v-model="newPassword"
                      :placeholder="
                        $t('customer.password_modal[0].enternewpass')
                      "
                      @input="validatePassword(newPassword)"
                      style="z-index:0"
                    />
                    <span class="input-group-btn">
                      <button
                        class="btn btn-default"
                        type="button"
                        @click="switchVisibility(2)"
                      >
                        <i :class="iconFieldTypeNewPass" />
                      </button>
                    </span>
                    <span
                      :class="{
                        password_length_count: valid_password_length,
                        show_password_length: password_typed
                      }"
                      class="password_length_modal"
                      style="z-index:0"
                      >{{ password_length }}</span
                    >
                  </div>
                  <div v-show="password_typed" class="lnu_container">
                    <p :class="{ got_lowercase: contain_lowercase }">
                      {{ $t("customer.password_modal[0].lowercase") }}
                    </p>
                    <p :class="{ got_number: contain_number }">
                      {{ $t("customer.password_modal[0].digit") }}
                    </p>
                    <p :class="{ got_uppercase: contain_uppercase }">
                      {{ $t("customer.password_modal[0].uppercase") }}
                    </p>
                  </div>
                </div>
              </b-form-group>
              <b-form-group
                :label="$t('customer.password_modal[0].confirmnewpass')"
              >
                <div class="form-group">
                  <div class="input-group">
                    <b-form-input
                      :type="ConfirmNewPasswordFieldType"
                      v-model="confirmNewPassword"
                      :placeholder="
                        $t('customer.password_modal[0].enternewpassconfirm')
                      "
                    />
                    <span class="input-group-btn">
                      <button
                        class="btn btn-default"
                        type="button"
                        @click="switchVisibility(3)"
                      >
                        <i :class="iconFieldTypeconfirmNewPass" />
                      </button>
                    </span>
                  </div>
                </div>
              </b-form-group>

              <b-button
                ref="formsubmitbutton_changepassword"
                type="submit"
                variant="primary"
                style="display: none;"
                >{{ $t("customer.password_modal[0].btn[0]") }}</b-button
              >
            </b-form>
          </div>
          <div class="modal-footer">
            <!-- <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >{{$t('customer.password_modal[0].btn[2]')}}</button> -->
            <button
              type="button"
              class="btn btn-primary pull-left"
              @click="onUpdatePassword"
            >
              {{ $t("customer.password_modal[0].btn[1]") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <!-- Inform modal -->
    <div class="modal modal-default" id="inform_modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("customer.inform_modal[0].title") }}
            </h4>
          </div>
          <div class="modal-body">
            <h5 class="modal-title">{{ $t(modal_title) }}</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-right"
              data-dismiss="modal"
            >
              {{ $t("customer.inform_modal[0].modal_btn[0].close") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <!-- //////////////////////////////////////////modal-change-email/////////////////////////////////////////////////////////// -->
    <!-- modal-change-email -->
    <div class="modal modal-default" id="modal-change-email">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h1 class="modal-title">
              {{ $t("user.change_email_modal[0].title") }}
            </h1>
            <!-- <p style="margin-top: 30px">{{$t('user.password_modal[0].guide')}}</p> -->
          </div>
          <div class="modal-body">
            <b-form>
              <b-form-group :label="$t('user.change_email_modal[0].old_email')">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      :type="OldEmailFieldType"
                      v-model="oldEmail"
                      :placeholder="
                        $t('user.change_email_modal[0].enter_old_email')
                      "
                      class="form-control"
                      :disabled="true"
                    />
                    <span class="input-group-btn">
                      <button class="btn btn-default" type="button">
                        <i :class="iconFieldTypeOldEmail" />
                      </button>
                    </span>
                  </div>
                </div>
              </b-form-group>

              <b-form-group :label="$t('user.change_email_modal[0].new_email')">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      :type="NewEmailFieldType"
                      @input="validateEmail(newEmail)"
                      v-model="newEmail"
                      :placeholder="
                        $t('user.change_email_modal[0].enter_new_email')
                      "
                      class="form-control"
                      style="z-index:0"
                    />
                    <span class="input-group-btn">
                      <button class="btn btn-default" type="button">
                        <i :class="iconFieldTypeNewEmail" />
                      </button>
                    </span>

                    <span v-if="this.newEmail != ''" class="help is-danger">
                      <font color="red">{{ $t(field_required.email) }}</font>
                    </span>
                  </div>
                </div>
              </b-form-group>

              <b-button
                ref="formsubmitbuttonsendmail"
                type="submit"
                variant="primary"
                style="display: none;"
                >{{ $t("user.change_email_modal[0].btn[0]") }}</b-button
              >
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary pull-left"
              @click="showConfirmEmail"
            >
              {{ $t("user.change_email_modal[0].btn[1]") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- ////////////////////////////////////////////modal-change-email///////////////////////////////////////////////////////// -->

    <!-- start modal-confirm-change-email  -->
    <div class="modal modal-default" id="modal-confirm-change-email">
      <div class="modal-dialog">
        <div class="modal-content" style="top: 100px">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("confirm_email.title") }}</h4>
          </div>
          <div class="modal-body">
            <p>
              {{ $t("confirm_email.content_with_param") }}
              <span style="font-weight: bold;">{{ oldEmail }}</span>
              {{ $t("confirm_email.content_with_param_to") }}
              <span style="font-weight: bold;">{{ newEmail }}</span>
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("confirm_email.btnClose") }}
            </button>

            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onUpdateEmail"
            >
              {{ $t("confirm_email.btnConfirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- end modal-confirm-change-email  -->

    <!-- start modal-confirm-reset-password  -->
    <div class="modal modal-default" id="modal-confirm-reset-password">
      <div class="modal-dialog">
        <div class="modal-content" style="top: 100px">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("confirm_pass.title") }}</h4>
          </div>
          <div class="modal-body">
            <p>{{ $t("confirm_pass.content") }}</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("confirm_email.btnClose") }}
            </button>

            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="passwodReset"
            >
              {{ $t("confirm_email.btnConfirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- end modal-confirm-reset-password  -->

    <!-- start modal edit user export info -->
    <div class="modal modal-default" id="modal-edit-user-export-info">
      <div class="modal-dialog">
        <div class="modal-content" style="top: 100px">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("customer.confirm_user_export_info_list") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <label>{{
                  $t(`customer.info_invoice.profile_company_name`)
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="
                    $t('customer.info_invoice.profile_company_name')
                  "
                  v-model="itemUserExportInfo.name"
                />
              </div>
              <div class="col-md-6">
                <label>{{
                  $t(`customer.info_invoice.profile_company_address`)
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="
                    $t('customer.info_invoice.profile_company_address')
                  "
                  v-model="itemUserExportInfo.registered_address"
                />
              </div>
            </div>
            <div class="row" style="margin-top: 15px;">
              <div class="col-md-6">
                <label>{{
                  $t(`customer.info_invoice.profile_company_tax_code`)
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="
                    $t('customer.info_invoice.profile_company_tax_code')
                  "
                  v-model="itemUserExportInfo.vat_code"
                />
              </div>
              <div class="col-md-6">
                <label>{{
                  $t(`customer.info_invoice.profile_company_email`)
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="
                    $t('customer.info_invoice.profile_company_email')
                  "
                  v-model="itemUserExportInfo.registered_email"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("confirm_email.btnClose") }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-left"
              @click="onEditUserExportInfo($event)"
            >
              {{ $t("confirm_email.btnConfirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- end modal edit user export info -->
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from "moment";
import Avatar from "@/components/Avatar/Avatar.vue";
import Loading from "vue-loading-overlay";
import { mapGetters, mapActions } from "vuex";
import constantsData from "@/lib/constantsData";
import utils from '@/lib/utils';
// import RelativesView from "./RelativesView";
// import RelatedResidentsView from "./RelatedResidentsView";
// import ResidentCards from "./ResidentCards";
// import RegisterVehicleView from "./RegisterVehicleView";
import RegisterOtherInfoView from "./RegisterOtherInfoView";
import AddCustomerIntoApartment from "./AddCustomerIntoApartment"
import Enum from "../../../enum/enum";
export default {
  name: "CustomerAddPersonal",
  props: {
    customer_id: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    callback: {
      type: String
    }
  },
  data() {
    return {
      userExportInforList: [],
      userExportInforFields: [
        {
          key: "name",
          label: "customer.info_invoice.profile_company_name",
          class: "text-center"
        },
        {
          key: "is_default",
          label: "customer.user_export_info_default",
          class: "text-center"
        },
        {
          key: "registered_address",
          label: "customer.info_invoice.profile_company_address",
          class: "text-center"
        },
        {
          key: "vat_code",
          label: "customer.info_invoice.profile_company_tax_code",
          class: "text-center"
        },
        {
          key: "registered_email",
          label: "customer.info_invoice.profile_company_email",
          class: "text-center"
        },
        { key: "actions", label: "common.action", class: "text-center" }
      ],
      savecontinue: false,
      ischeck: false,
      assignShow: false,
      actionType: "",
      timeCurrent: "2019-01-16T06:00:00Z",
      vehicles: [],
      relatedresidentsitems: [],
      relativesitems: [],
      cards: [],
      customerdata: {
        id: 0,
        password: constantsData.password_default.password,
        last_login: this.timeCurrent,
        is_superuser: false,
        username: "",
        fullname: null,
        email: null,
        is_staff: false,
        is_active: true,
        date_joined: this.timeCurrent,
        groups: 4,
        reward_point: 0,
        privilege: 7,
        dob: "01-01-1990",
        phone: "",
        gender: null,
        crmcode: "",
        country_code: null,

        company_name: "",
        company_address: "",
        company_tax_code: null,
        company_email: null,
        company_phone: null,

        // [loitt] - #1459: THÊM LOẠI KHÁCH HÀNG - TẠO MỚI KH
        group: 1,
        personal_tax_code: "",
        profile_representative_name: "",
        profile_representative_phone: "",

        company_website: null,
        representative_name: null,
        representative_email: null,
        representative_phone: null,
        representative_identificationnumber: null,
        representative_passport: null,
        representative_position: null,

        is_company: 0,
        url_avatar: "",
        identificationnumber: "",
        passport: "",
        address: "",
        contacts: [
          {
            contact_person: null,
            cell_mobile_phone: null,
            email_address: null,
            address: null
          },
          {
            contact_person: null,
            cell_mobile_phone: null,
            email_address: null,
            address: null
          }
        ],

        profile_company_name: "",
        profile_company_address: "",
        profile_company_tax_code: "",
        profile_company_email: ""
      },
      options: {
        format: "DD-MM-YYYY",
        useCurrent: false,
        maxDate: moment().subtract(2, "days")
      },
      country_list: [],
      showPasswordText: true,
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      password_length: 0,
      password_typed: false,
      contain_lowercase: false,
      contain_uppercase: false,
      contain_number: false,
      valid_password_length: false,
      valid_password: false,
      modal_title: "",
      gender_list: constantsData.genderTypes,

      field_required: {
        fullname: "",
        email: "",
        password: constantsData.password_default.password
      },

      objectNameData: "this.userdata.",
      objectNameRequire: "this.field_required.",
      isLoading: false,
      in_charge_of_apartments: "",

      OldPasswordFieldType: "password",
      NewPasswordFieldType: "password",
      ConfirmNewPasswordFieldType: "password",

      iconFieldTypeOldPass: "glyphicon glyphicon-eye-open",
      iconFieldTypeNewPass: "glyphicon glyphicon-eye-open",
      iconFieldTypeconfirmNewPass: "glyphicon glyphicon-eye-open",
      isCurrentUser: false,

      // #615
      OldEmailFieldType: "email",
      NewEmailFieldType: "email",
      oldEmail: "",
      newEmail: "",
      iconFieldTypeOldEmail: "glyphicon glyphicon-envelope",
      iconFieldTypeNewEmail: "glyphicon glyphicon-envelope",
      valid_email: false,
      status_active: "X",
      show_email: false,
      email_activated: false,
      itemUserExportInfo: {},
      reward: {
        type: "",
        wanted_point: null,
        text: "",
        name: ""
      },
      contract_files: [],
      file_contract_list: [],
      date_uploaded: moment(Date.now()).format("DD-MM-YYYY"),
      fileNames: [],
      params_id: null,
      basepath: ""
    };
  },

  watch: {
    // watch customer detail
    CUSTOMER_DETAIL_DATA: function() {
      this.customerdata.password = this.CUSTOMER_DETAIL_DATA.password;
      this.customerdata.username = this.CUSTOMER_DETAIL_DATA.username;
      this.customerdata.fullname = this.CUSTOMER_DETAIL_DATA.last_name + " " + this.CUSTOMER_DETAIL_DATA.first_name;
      this.customerdata.email = this.CUSTOMER_DETAIL_DATA.email;

      // alway reset password #553
      // if(this.GET_ACCOUNT_DATA.email == this.CUSTOMER_DETAIL_DATA.email){
      //     this.isCurrentUser = true;
      // }

      if (this.CUSTOMER_DETAIL_DATA.profile === undefined) {
        this.customerdata.phone = "";
        this.customerdata.dob = null;
        this.customerdata.gender = 0;
        this.customerdata.crmcode = "";
        this.customerdata.country_code = "";
        this.customerdata.company_name = "";
        this.customerdata.company_address = "";
        this.customerdata.company_tax_code = "";
        this.customerdata.company_email = "";
        this.customerdata.company_phone = "";
        this.customerdata.is_company = 1;
        this.customerdata.company_website = "";
        this.customerdata.representative_name = "";
        this.customerdata.representative_email = "";
        this.customerdata.representative_phone = "";
        this.customerdata.representative_identificationnumber = "";
        this.customerdata.address = "";
        this.customerdata.representative_passport = "";
        this.customerdata.representative_position = "";
        this.customerdata.identificationnumber = "";
        this.customerdata.passport = null;
        this.customerdata.url_avatar = "";
        this.email_activated = false;
        this.customerdata.reward_point = 0;

        this.customerdata.profile_company_name = "";
        this.customerdata.profile_company_address = "";
        this.customerdata.profile_company_tax_code = "";
        this.customerdata.profile_company_email = "";

        // [loitt] - #1459: THÊM LOẠI KHÁCH HÀNG - TẠO MỚI KH
        this.customerdata.personal_tax_code = "";
        this.customerdata.profile_representative_name = "";
        this.customerdata.profile_representative_phone = "";
      } else {
        this.customerdata.phone = utils.formatPhoneWithSpace(this.CUSTOMER_DETAIL_DATA.profile.phone, "");
        this.customerdata.dob = utils.formatSqlDate(this.CUSTOMER_DETAIL_DATA.profile.dob, null, "DD-MM-YYYY");
        this.customerdata.gender = this.CUSTOMER_DETAIL_DATA.profile.gender;
        (this.customerdata.crmcode = this.CUSTOMER_DETAIL_DATA.profile.customer_crm_code),
          (this.customerdata.country_code = this.CUSTOMER_DETAIL_DATA.profile.country_code);
        this.customerdata.company_name = this.CUSTOMER_DETAIL_DATA.profile.company_name;
        this.customerdata.company_address = this.CUSTOMER_DETAIL_DATA.profile.company_address;
        this.customerdata.company_tax_code = this.CUSTOMER_DETAIL_DATA.profile.company_tax_code;
        this.customerdata.company_email = this.CUSTOMER_DETAIL_DATA.profile.company_email;
        this.customerdata.company_phone = this.CUSTOMER_DETAIL_DATA.profile.company_phone;
        this.customerdata.is_company = this.CUSTOMER_DETAIL_DATA.profile.is_company;
        this.customerdata.reward_point = this.CUSTOMER_DETAIL_DATA.profile.reward_point;

        this.customerdata.company_website = this.CUSTOMER_DETAIL_DATA.profile.company_website;
        this.customerdata.representative_name = this.CUSTOMER_DETAIL_DATA.profile.representative_name;
        this.customerdata.representative_email = this.CUSTOMER_DETAIL_DATA.profile.representative_email;
        this.customerdata.representative_phone = this.CUSTOMER_DETAIL_DATA.profile.representative_phone;
        this.customerdata.representative_identificationnumber = this.CUSTOMER_DETAIL_DATA.profile.representative_identificationnumber;
        this.customerdata.representative_passport = this.CUSTOMER_DETAIL_DATA.profile.representative_passport;
        this.customerdata.representative_position = this.CUSTOMER_DETAIL_DATA.profile.representative_position;

        this.customerdata.identificationnumber = this.CUSTOMER_DETAIL_DATA.profile.identificationnumber;
        this.customerdata.address = this.CUSTOMER_DETAIL_DATA.profile.address;
        this.customerdata.passport = this.CUSTOMER_DETAIL_DATA.profile.passport;
        this.customerdata.url_avatar = this.CUSTOMER_DETAIL_DATA.profile.url_avatar;
        this.email_activated = this.CUSTOMER_DETAIL_DATA.profile.is_active;

        this.customerdata.profile_company_name = this.CUSTOMER_DETAIL_DATA.profile.profile_company_name;
        this.customerdata.profile_company_address = this.CUSTOMER_DETAIL_DATA.profile.profile_company_address;
        this.customerdata.profile_company_tax_code = this.CUSTOMER_DETAIL_DATA.profile.profile_company_tax_code;
        this.customerdata.profile_company_email = this.CUSTOMER_DETAIL_DATA.profile.profile_company_email;

        // [loitt] - #1459: THÊM LOẠI KHÁCH HÀNG - TẠO MỚI KH
        this.customerdata.personal_tax_code = this.CUSTOMER_DETAIL_DATA.profile.personal_tax_code;
        this.customerdata.profile_representative_name = this.CUSTOMER_DETAIL_DATA.profile.profile_representative_name;
        this.customerdata.profile_representative_phone = this.CUSTOMER_DETAIL_DATA.profile.profile_representative_phone;
        this.customerdata.group = this.CUSTOMER_DETAIL_DATA.profile.group;
      }
      // BEGIN - [loitt] - check is active
      if (this.email_activated === true) {
        this.status_active = "";
        this.email_activated = true;
      } else {
        this.status_active = "X";
        this.email_activated = false;
      }
      // END   - [loitt] - check is active
      this.customerdata.password = this.CUSTOMER_DETAIL_DATA.password;
      let groups = 1; // default is 1
      if (
        this.customerdata.groups != undefined &&
        this.CUSTOMER_DETAIL_DATA.groups.length > 0
      ) {
        groups = this.CUSTOMER_DETAIL_DATA.groups[0].id;
      }
      this.customerdata.groups = groups;
      this.customerdata.privilege =
        this.CUSTOMER_DETAIL_DATA.privilege.length > 0
          ? this.CUSTOMER_DETAIL_DATA.privilege[0].id
          : null;
      this.CUSTOMER_DETAIL_DATA.contacts.forEach((contact, i) => {
        this.customerdata.contacts[i].contact_person = contact.contact_person;
        this.customerdata.contacts[i].cell_mobile_phone =
          contact.cell_mobile_phone;
        this.customerdata.contacts[i].email_address = contact.email_address;
        this.customerdata.contacts[i].address = contact.address;
      });
      this.REWARD_POINT_DATA();
      this.$emit("customerdata", this.customerdata);
    },
    GET_UPLOAD_USER_LIST: function() {
      this.file_contract_list = [];
      this.GET_UPLOAD_USER_LIST.forEach(file => {
        let data = {
          id: file.id,
          name: file.file_name,
          date_upload: utils.formatSqlDate(file.date_created, null, "DD-MM-YYYY"),
          size: file.size,
          url: file.url
        };
        this.file_contract_list.push(data);
      });
    }
  },

  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "CUSTOMER_DETAIL_DATA",
      "UPDATE_CUSTOMER_DATA",
      "GET_MEMBERROLECODES_DATA",
      "GET_ACCOUNT_DATA",
      "GET_REWARD_POINT_DATA",
      "GET_UPLOAD_USER_LIST"
    ]),
    privilegeOptions: function() {
      return this.privilege.customer;
    }
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ADD_CUSTOMER",
      "UPDATE_CUSTOMER",
      "UPDATE_CUSTOMER_EMAIL",
      "ON_SHOW_TOAST",
      "GET_COUNTRY_LIST",
      "GET_APARTMENT_RESIDENT_SEARCH",
      "GET_CARDS_LIST",
      "ACCOUNT_PASSWORD_RESET",
      "RESEND_ACTIVE_EMAIL_CUSTOMER",
      "FORCE_ACTIVE_EMAIL_CUSTOMER",
      "CREATE_USER_EXPORT_INFO",
      "GET_USER_EXPORT_INFO_LIST",
      "UPDATE_USER_EXPORT_INFO",
      "DELETE_USER_EXPORT_INFO",
      "GET_REWARD_POINT",
      "UPLOAD_FILE_USER",
      "GET_UPLOAD_USER_DATA",
      "DELETE_FILE_URL_USER",
      "GET_CUSTOMER_DETAIL"
    ]),

    giveRewardPoint: function() {
      this.$router.push({
        name: "CustomerGiveRewardPoint",
        query: {
          current_customer: this.customerdata.id,
          params_id: this.$route.params.id,
          query_link: this.$route.query,
          reward_point: this.customerdata.reward_point
        }
      });
    },
    REWARD_POINT_DATA: function() {
      let user_point = this.customerdata.reward_point;
      let silver_point = this.GET_REWARD_POINT_DATA[1].reward_point;
      let gold_point = this.GET_REWARD_POINT_DATA[2].reward_point;
      let platinum_point = this.GET_REWARD_POINT_DATA[3].reward_point;

      let bronze_name = this.$t("reward." + this.GET_REWARD_POINT_DATA[0].name);
      let silver_name = this.$t("reward." + this.GET_REWARD_POINT_DATA[1].name);
      let gold_name = this.$t("reward." + this.GET_REWARD_POINT_DATA[2].name);
      let platinum_name = this.$t(
        "reward." + this.GET_REWARD_POINT_DATA[3].name
      );

      if (user_point >= platinum_point) {
        this.reward.type = platinum_name;
        this.reward.name = "platinum";
        this.reward.wanted_point = null;
        this.reward.text =
          this.$t("reward.congrat") + " " + platinum_name.toLowerCase();
        return;
      } else if (user_point >= gold_point && user_point < platinum_point) {
        this.reward.type = gold_name;
        this.reward.name = "gold";
        this.reward.wanted_point =
          platinum_point - this.customerdata.reward_point;
        this.reward.text =
          this.$t("reward.need_more") +
          " " +
          this.reward.wanted_point +
          " " +
          this.$t("reward.text_comming_type") +
          " " +
          platinum_name.toLowerCase();
        return;
      } else if (user_point >= silver_point && user_point < gold_point) {
        this.reward.type = silver_name;
        this.reward.name = "silver";
        this.reward.wanted_point = gold_point - this.customerdata.reward_point;
        this.reward.text =
          this.$t("reward.need_more") +
          " " +
          this.reward.wanted_point +
          " " +
          this.$t("reward.text_comming_type") +
          " " +
          gold_name.toLowerCase();
        return;
      } else if (user_point < silver_point) {
        this.reward.type = bronze_name;
        this.reward.name = "bronze";
        this.reward.wanted_point =
          silver_point - this.customerdata.reward_point;
        this.reward.text =
          this.$t("reward.need_more") +
          " " +
          this.reward.wanted_point +
          " " +
          this.$t("reward.text_comming_type") +
          " " +
          silver_name.toLowerCase();
        return;
      }
    },
    onChangeGroups(event) {
    },
    selectUserExportInfoDefault: function(row) {
      row.item.is_default = true;
      let data = row.item;
      this.UPDATE_USER_EXPORT_INFO({
        id: row.item.id,
        ...data,
        is_update_user_export_default: true
      }).then(
        function(res) {
          this.getUserExportInfoList();
          this.SUCCESS_TOAST();
        }.bind(this)
      );
    },
    addUserExportInfo: function(event) {
      event.preventDefault();
      if (
        utils.isNull(this.customerdata.profile_company_name) ||
        utils.isNull(this.customerdata.profile_company_address) ||
        utils.isNull(this.customerdata.profile_company_tax_code) ||
        utils.isNull(this.customerdata.profile_company_email)
      ) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.please_enter_fields"),
          styleType: "danger"
        });
        return;
      } else {
        let data = {
          user_id: this.customerdata.id,
          name: this.customerdata.profile_company_name,
          vat_code: this.customerdata.profile_company_tax_code,
          registered_address: this.customerdata.profile_company_address,
          registered_email: this.customerdata.profile_company_email,
          is_default: false
        };
        this.CREATE_USER_EXPORT_INFO(data)
          .then(
            function(res) {
              this.getUserExportInfoList();
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              if (error.response.data.error_code == "vat_code_is_exist") {
                this.ON_SHOW_TOAST({
                  message: this.$t("customer.tax_code_already"),
                  styleType: "danger"
                });
              } else {
                this.ON_SHOW_TOAST({
                  message: this.$t("common.an_error_occurred"),
                  styleType: "danger"
                });
              }
            }.bind(this)
          );
      }
    },
    getUserExportInfoList: function() {
      let data = {
        params: {
          user_id: this.customerdata.id
        }
      };
      this.GET_USER_EXPORT_INFO_LIST(data).then(
        function(res) {
          let data = res;
          this.userExportInforList = data;
        }.bind(this)
      );
    },
    editUserExportInfo: function(event, item) {
      event.preventDefault();
      this.itemUserExportInfo = item;
      $("#modal-edit-user-export-info").modal("show");
    },
    onEditUserExportInfo: function(event) {
      event.preventDefault();
      if (
        this.itemUserExportInfo.name == "" ||
        this.itemUserExportInfo.vat_code == "" ||
        this.itemUserExportInfo.registered_address == "" ||
        this.itemUserExportInfo.registered_email == ""
      ) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.please_enter_fields"),
          styleType: "danger"
        });
        return;
      } else {
        this.UPDATE_USER_EXPORT_INFO({
          id: this.itemUserExportInfo.id,
          ...this.itemUserExportInfo,
          is_update_user_export_default: false
        })
          .then(
            function(res) {
              $("#modal-edit-user-export-info").modal("hide");
              this.getUserExportInfoList();
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              if (error.response.data.error_code == "vat_code_is_exist") {
                this.getUserExportInfoList();
                this.ON_SHOW_TOAST({
                  message: this.$t("customer.tax_code_already"),
                  styleType: "danger"
                });
              } else {
                this.ON_SHOW_TOAST({
                  message: this.$t("common.an_error_occurred"),
                  styleType: "danger"
                });
              }
            }.bind(this)
          );
      }
    },
    deleteUserExportInfo: function(event, item) {
      event.preventDefault();
      this.DELETE_USER_EXPORT_INFO({ id: item.id }).then(
        function(res) {
          this.getUserExportInfoList();
          this.SUCCESS_TOAST();
        }.bind(this)
      );
    },
    // this.$t("customer.error_messages.email_exist")
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    showSuccess: function(msg) {
      this.ON_SHOW_TOAST({
        message: msg,
        styleType: "success"
      });
    },

    // #615
    clickOpenModalChangeEmail: function() {
      $("#modal-change-email").modal("show");
      this.newEmail = "";
      this.oldEmail = this.customerdata.email;
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    getCardsList: function(data) {
      if (this.customerdata.id == 0) {
        return;
      }
      const payload = {
        params: {
          user: this.customerdata.id
        }
      };
      this.GET_CARDS_LIST(payload);
    },
    // add show/hide password
    switchVisibility: function(typePass) {
      if (typePass == 3) {
        this.ConfirmNewPasswordFieldType =
          this.ConfirmNewPasswordFieldType === "password" ? "text" : "password";
        this.iconFieldTypeconfirmNewPass =
          this.ConfirmNewPasswordFieldType === "password"
            ? "glyphicon glyphicon-eye-open"
            : "glyphicon glyphicon-eye-close";
      }
      if (typePass == 2) {
        this.NewPasswordFieldType =
          this.NewPasswordFieldType === "password" ? "text" : "password";
        this.iconFieldTypeNewPass =
          this.NewPasswordFieldType === "password"
            ? "glyphicon glyphicon-eye-open"
            : "glyphicon glyphicon-eye-close";
      }
      if (typePass == 1) {
        this.OldPasswordFieldType =
          this.OldPasswordFieldType === "password" ? "text" : "password";
        this.iconFieldTypeOldPass =
          this.OldPasswordFieldType === "password"
            ? "glyphicon glyphicon-eye-open"
            : "glyphicon glyphicon-eye-close";
      }
    },
    // [loitt] - add validate Email empty and incorrect format
    validateEmailAll: function(
      field,
      objectName = "this.customerdata.",
      objectNameRequire = "this.field_required."
    ) {
      // use for get value : this.customer.last_name
      let exec = objectName + field;

      // this.field_required.last_name
      let error_msg = objectNameRequire + field;

      // Init data befor check
      eval(error_msg + " = ''");

      // ==> get value current
      let result = eval(exec);

      if (result == null || result == "") {
        eval(error_msg + " = 'common.error_msg[0].required'");
      } else {
        let isEmailValid = this.validateEmail(result);
        if (!isEmailValid) {
          eval(error_msg + " = 'user.inform_modal[0].email_error'");
        }
      }

      return result;
    },

    // [loitt] - add validate Field Is Empty
    validateFieldIsEmpty: function(
      field,
      objectName = "this.customerdata.",
      objectNameRequire = "this.field_required."
    ) {
      // use for get value : this.userdata.last_name
      let exec = objectName + field;

      // this.field_required.last_name
      let error_msg = objectNameRequire + field;

      // Init data befor check
      eval(error_msg + " = ''");

      // ==> get value current
      let result = eval(exec);

      if (result == null || result == "") {
        eval(error_msg + " = 'common.error_msg[0].required'");
      }

      return result;
    },

    handleCompleted(url_avatar) {
      this.customerdata.url_avatar = url_avatar;
    },
    callBackToList: function() {
      if (!this.savecontinue) {
        this.$router.push({
          name: "Customer"
        });
      } else {
        this.$router.push({
          name: "CustomerAdd",
          params: {
            id: this.customerdata.id
          }
        });
      }
    },
    onOpenServices: function() {
      this.$router.push({
        name: "ServiceHistory"
      });
    },
    onCurrentService: function() {
      this.$router.push({
        name: "ServiceAssigned"
      });
    },
    CancelCustomerList: function() {
      this.savecontinue = false;
      this.callBackToList();
    },
    showConfirmPass: function() {
      $("#modal-confirm-reset-password").modal("show");
    },
    passwodReset: function() {
      $("#modal-confirm-reset-password").modal("hide");
      let payload = {
        email_or_username: this.customerdata.email,
        domain: Enum.domain
      };
      this.ACCOUNT_PASSWORD_RESET(payload)
        .then(
          function() {
            this.ON_SHOW_TOAST({
              message: this.$t("customer.info_send_email", {
                "0": this.customerdata.email
              }),
              styleType: "success"
            });
            // this.$router.push({ name: "PasswordResetDone" });
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    showModal: function() {
      $("#modal-newpassword").modal("show");
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmNewPassword = "";
      this.password_length = 0;
      this.password_typed = false;
      this.contain_lowercase = false;
      this.contain_uppercase = false;
      this.contain_number = false;
      this.valid_password_length = false;
      this.valid_password = false;
    },
    onUpdatePassword: function() {
      if (
        this.newPassword === "" ||
        this.oldPassword === "" ||
        this.confirmNewPassword === ""
      ) {
        let required_title = "customer.inform_modal[0].empty_error";
        this.showInformmodal(required_title);
      } else if (this.newPassword !== this.confirmNewPassword) {
        let confirm_title = "customer.inform_modal[0].confirm_error";
        this.showInformmodal(confirm_title);
      } else if (this.valid_password == false) {
        let weakpass_title = "customer.inform_modal[0].passwordInvalidate";
        this.showInformmodal(weakpass_title);
      } else {
        $("#modal-newpassword").modal("hide");
        let data = {
          id: this.customerdata.id,
          password: this.newPassword,
          obsoletepassword: this.oldPassword
        };
        this.UPDATE_CUSTOMER(data)
          .then(
            function(res) {
              let success_title = "customer.inform_modal[0].updated_success";
              this.showInformmodal(success_title);
            }.bind(this)
          )
          .catch(
            function() {
              let failed_title = "customer.inform_modal[0].oldpass_error";
              this.showInformmodal(failed_title);
            }.bind(this)
          );
      }
    },
    validateData: function() {
      let validatedResult = "OK";
      let isEmailValid = this.validateEmail(this.customerdata.email);

      for (let key in this.customerdata) {
        if (
          key == "crmcode" ||
          key == "country_code" ||
          key == "company_name" ||
          key == "company_address" ||
          key == "company_tax_code" ||
          key == "company_email" ||
          key == "company_phone" ||
          key == "company_website" ||
          key == "personal_tax_code" ||
          key == "url_avatar" ||
          key == "company_website" ||
          key == "representative_name" ||
          key == "representative_email" ||
          key == "representative_phone" ||
          key == "representative_identificationnumber" ||
          key == "representative_passport" ||
          key == "representative_position" ||
          key == "passport" ||
          key == "identificationnumber" ||
          key == "profile_company_name" ||
          key == "profile_company_address" ||
          key == "profile_company_tax_code" ||
          key == "profile_company_email"||
          key == "gender"
        ) {
          // not validating 'crmcode' field

          // validate CMND - # issue 188
          if (
            key == "identificationnumber" &&
            this.customerdata[key] !== null &&
            this.customerdata[key] !== ""
          ) {
            let lenIdentificationNumber = this.customerdata[key].length;
            if (
              lenIdentificationNumber > 0 &&
              !(lenIdentificationNumber == 9 || lenIdentificationNumber == 12)
            ) {
              validatedResult =
                "CMND phải có chiều dài của chuỗi là 9 hoặc 12 ký tự";
              break;
            }
          }

          // validate passport - # issue 188
          if (
            key == "passport" &&
            this.customerdata[key] !== null &&
            this.customerdata[key] !== ""
          ) {
            let passport = this.customerdata[key].length;
            if (passport > 0 && !(7 < passport && passport < 15)) {
              validatedResult =
                "Passport phải có chiều dài chuỗi lớn hơn 7 và nhỏ hơn 15";
              break;
            }
          }
        } else if (
          this.customerdata["phone"] != "" &&
          this.customerdata["phone"] != null
        ) {
          let isPhoneValid = utils.validatePhone(
            this.customerdata["phone"].replace(/ /g, "")
          );
          if (!isPhoneValid) {
            validatedResult = this.$t(
              "user.inform_modal[0].phone_number_error"
            );
          }
        } 
        // else if (
        //   (this.customerdata[key] === null || this.customerdata[key] === "") &&
        //   key != "phone" &&
        //   key !== "username" &&
        //   key != "profile_representative_phone" &&
        //   key != "profile_representative_name"
        // ) {
        //   validatedResult = key + " " + this.$t("customer.not_empty");
        // } 
        else if (!isEmailValid) {
          validatedResult = this.$t("user.inform_modal[0].email_error");
          break;
        }
      }

      // [loitt] - #1459: THÊM LOẠI KHÁCH HÀNG - TẠO MỚI KH
      if (
        this.customerdata["profile_representative_phone"] != "" &&
        this.customerdata["profile_representative_phone"] != null
      ) {
        let isPhoneValid = utils.validatePhone(
          this.customerdata["profile_representative_phone"].replace(/ /g, "")
        );
        if (!isPhoneValid) {
          validatedResult = this.$t(
            "user.inform_modal[0].profile_representative_phone_error"
          );
        }
      }

      // [loitt]  - #395 Check CMND và Hộ Chiếu, thì bắt buộc nhập 1 trong 2
      // if(this.customerdata.identificationnumber == "" && this.customerdata.passport == ""){
      //     validatedResult = this.$t('customer.passport_identificationnumber');
      // }

      // check contact != NULL
      // if (this.$route.params.id != 0) {
      //     for (let index = 0; index < this.customerdata.contacts.length; index++) {
      //         const element = this.customerdata.contacts[index];
      //         for (let column in element) {
      //             if (column == 'contact_person') {
      //                 if ((element[column] === null || element[column] === "")) {
      //                     validatedResult = this.$t('customer.contact_person_validate');
      //                     break;
      //                 }
      //             }
      //             if (column == 'cell_mobile_phone') {
      //                 if ((element[column] === null || element[column] === "")) {
      //                     validatedResult = this.$t('customer.cell_mobile_phone_validate');
      //                     break;
      //                 }
      //             }
      //         }
      //     }
      // }
      return validatedResult;
    },
    isNumeric(num) {
      return !isNaN(num);
    },
    checkForm: function() {
      let result_error = "OK";
      for (var key in this.field_required) {
        if (key === "email") {
          this.validateEmailAll(key);
        } else {
          if (!(key === "password" && this.$route.params.id != 0)) {
            this.validateFieldIsEmpty(key);
          }
        }

        let key_error = this.objectNameRequire + key;
        let t_result = eval(key_error);
        if (
          key_error == "this.field_required.password" &&
          t_result == "Rpp@1234"
        ) {
          t_result = this.$t("error_messages.password_invalid");
        }
        if (t_result != "" && key != "password") {
          result_error = t_result;
        }
      }

      return result_error;
    },
    SaveCustomerList: function(event) {
      this.waitingLoading(true);
      event.preventDefault();
      // [loitt] - changed validate data #266
      let result = this.checkForm(); // validateData
      if (result == "OK") {
        result = this.validateData();
      }

      if (result == "OK") {
        let groups = 1; // default is 1
        if (this.customerdata.groups != undefined) {
          groups = this.customerdata.groups;
        }
        let contacts = [];
        this.customerdata.contacts.forEach(contact => {
          let contact_data = {
            contact_person: contact.contact_person,
            cell_mobile_phone: contact.cell_mobile_phone,
            email_address: contact.email_address,
            address: contact.address
          };
          contacts.push(contact_data);
        });
        let data = {
          last_login: this.timeCurrent, // need set time
          is_superuser: false,
          username: this.customerdata.email,
          first_name: utils.getFirstLastName(this.customerdata.fullname).firstName,
          last_name: utils.getFirstLastName(this.customerdata.fullname).lastName,
          email: this.customerdata.email,
          is_staff: false,
          is_active: true,
          date_joined: this.timeCurrent, // need set time
          groups: [groups], // this is array
          // infor profile
          profile: [
            {
              dob: utils.formatSqlDate(this.customerdata.dob, "DD-MM-YYYY", "YYYY-MM-DD"),
              phone: this.customerdata.phone.replace(/ /g, ""),
              gender: this.customerdata.gender,
              customer_crm_code: this.customerdata.crmcode,
              country_code: this.customerdata.country_code,
              reward_point: this.customerdata.reward_point,
              url_avatar: this.customerdata.url_avatar,
              identificationnumber: this.customerdata.identificationnumber,
              address: this.customerdata.address,
              passport: this.customerdata.passport,
              is_company: 0, // this is personal
              company_name: this.customerdata.company_name,
              company_address: this.customerdata.company_address,
              company_tax_code: this.customerdata.company_tax_code,
              company_email: this.customerdata.company_email,
              company_phone: this.customerdata.company_phone,
              company_website: this.customerdata.company_website,
              representative_name: this.customerdata.representative_name,
              representative_email: this.customerdata.representative_email,
              representative_phone: this.customerdata.representative_phone,
              representative_identificationnumber: this.customerdata.representative_identificationnumber,
              representative_passport: this.customerdata.representative_passport,
              representative_position: this.customerdata.representative_position,

              profile_company_name: this.customerdata.profile_company_name,
              profile_company_address: this.customerdata.profile_company_address,
              profile_company_tax_code: this.customerdata.profile_company_tax_code,
              profile_company_email: this.customerdata.profile_company_email,

              // [loitt] - #1459: THÊM LOẠI KHÁCH HÀNG - TẠO MỚI KH
              group: this.customerdata.group,
              personal_tax_code: this.customerdata.personal_tax_code,
              profile_representative_name: this.customerdata.profile_representative_name,
              profile_representative_phone: this.customerdata.profile_representative_phone
            }
          ],
          // privilege
          privilege: [this.customerdata.privilege],
          // contacts
          contacts: contacts,
          id: this.customerdata.id
        };
        if (parseInt(this.customerdata.id) == 0) {
          data["password"] = constantsData.password_default.password;
          data["domain"] = Enum.domain;
          this.ADD_CUSTOMER(data)
            .then(
              function(res) {
                this.waitingLoading(false);
                this.ON_SHOW_TOAST({
                  message: this.$t("customer.info_send_email", {
                    "0": this.customerdata.email
                  }),
                  styleType: "success"
                });
                this.getCardsList();
                this.GET_REWARD_POINT();
                this.customerdata.id = res.id;
                this.callBackToList();
              }.bind(this)
            )
            .catch(
              function(error) {
                let error_message = error.response.data.message;
                switch (error_message) {
                  case "duplicatedemail":
                    this.waitingLoading(false);
                    this.ON_SHOW_TOAST({
                      message: this.$t(
                        "customer.error_messages.duplicated_email"
                      ),
                      styleType: "danger"
                    });
                    break;
                  case "UniqueUsername":
                    this.waitingLoading(false);
                    this.ON_SHOW_TOAST({
                      message: this.$t(
                        "customer.error_messages.duplicated_username"
                      ),
                      styleType: "danger"
                    });
                    break;
                  default:
                    this.waitingLoading(false);
                    if (error_message.includes("no_uppercase")) {
                      this.ON_SHOW_TOAST({
                        message: this.$t(
                          "customer.error_messages.password_uppercase"
                        ),
                        styleType: "danger"
                      });
                    } else if (error_message.includes("no_lowercase")) {
                      this.ON_SHOW_TOAST({
                        message: this.$t(
                          "customer.error_messages.password_lowercase"
                        ),
                        styleType: "danger"
                      });
                    } else if (error_message.includes("no_digit")) {
                      this.ON_SHOW_TOAST({
                        message: this.$t(
                          "customer.error_messages.password_nodigit"
                        ),
                        styleType: "danger"
                      });
                    } else if (error_message.includes("short")) {
                      this.ON_SHOW_TOAST({
                        message: this.$t(
                          "customer.error_messages.password_short"
                        ),
                        styleType: "danger"
                      });
                    } else if (error_message.includes("email")) {
                      this.ON_SHOW_TOAST({
                        message: this.$t("customer.error_messages.email_exist"),
                        styleType: "danger"
                      });
                    } else if (error_message.includes("project")) {
                      this.ON_SHOW_TOAST({
                        message: this.$t(
                          "customer.error_messages.email_exist_project"
                        ),
                        styleType: "danger"
                      });
                    } else {
                      this.ON_SHOW_TOAST({
                        message: error_message,
                        styleType: "danger"
                      });
                    }
                    break;
                }
              }.bind(this)
            );
        } else {
          this.UPDATE_CUSTOMER(data)
            .then(
              function() {
                this.SUCCESS_TOAST();
                this.waitingLoading(false);
                this.getCardsList();
                this.callBackToList();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.waitingLoading(false);
                // alert("Error Update");
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
      } else if (result != "OK") {
        this.waitingLoading(false);
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      } else {
        this.waitingLoading(false);
        this.ON_SHOW_TOAST({
          message: "This password is not valid",
          styleType: "danger"
        });
      }
    },
    isCheck: function() {
      this.customerdata.is_company = this.customerdata.is_company == 0 ? 1 : 0;
      this.ischeck = this.customerdata.is_company == 1 ? true : false;
    },
    onSave: function(cont = false) {
      this.savecontinue = cont;
      this.$refs.formsubmitbutton.click();
    },
    showInformmodal: function(title) {
      this.modal_title = title;
      $("#inform_modal").modal("show");
    },
    validatePassword: function(password) {
      this.password_length = password.length;
      if (this.password_length <= 0) {
        this.field_required.password = "common.error_msg[0].required";
        return;
      }

      if (this.password_length > 7) {
        this.valid_password_length = true;
      } else {
        this.valid_password_length = false;
      }

      if (this.password_length > 0) {
        this.password_typed = true;
      } else {
        this.password_typed = false;
      }

      this.contain_lowercase = /[a-z]/.test(password);
      this.contain_uppercase = /[A-Z]/.test(password);
      this.contain_number = /\d/.test(password);

      if (
        this.contain_lowercase == true &&
        this.contain_uppercase == true &&
        this.contain_number == true &&
        this.valid_password_length == true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },
    handleUpload() {
      this.$refs["files"].click();
    },
    removeUrl: function(id) {
      const contract = {
        params: {
          id: parseInt(this.params_id)
        }
      };
      this.isLoading = true;

      this.DELETE_FILE_URL_USER({ id: id })
        .then(
          function() {
            this.isLoading = false;
            this.GET_UPLOAD_USER_DATA(contract);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
            this.ERROR_TOAST();
          }.bind(this)
        );
      this.fileNames = [];
    },
    readFileSize(size) {
      if (size < 1024) return size + " B";
      let i = Math.floor(Math.log(size) / Math.log(1024));
      let num = size / Math.pow(1024, i);
      let round = Math.round(num);
      num = round < 10 ? num.toFixed(2) : round < 100 ? num.toFixed(1) : round;
      return `${num} ${"KMGTPEZY"[i - 1]}B`;
    },
    removeFile(key) {
      this.contract_files.splice(key, 1);
      this.fileNames.splice(key, 1);
    },
    Upload_file: function() {
      let formData = new FormData();
      const contract = {
        params: {
          id: parseInt(this.params_id)
        }
      };
      for (var i = 0; i < this.contract_files.length; i++) {
        let file = this.contract_files[i];
        formData.append("files[" + i + "]", file);
      }
      formData.append("user_id", this.params_id);
      this.isLoading = true;
      this.UPLOAD_FILE_USER(formData).then(
          function() {
            this.isLoading = false;
            this.GET_UPLOAD_USER_DATA(contract);
            this.contract_files = [];
            $(this.$refs["modal-import"]).modal("hide");
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
            $(this.$refs["modal-import"]).modal("hide");
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    handleFilesUpload: function() {
      let uploadedFiles = this.$refs.files.files;

      let fileNameExist = "";
      let file_ext = ["exe", "mp4", "mp3"];

      for (var i = 0; i < uploadedFiles.length; i++) {
        let fileName = uploadedFiles[i].name;
        let extension = fileName.substring(fileName.lastIndexOf(".") + 1);
        if (file_ext.includes(extension)) {
          this.ON_SHOW_TOAST({
            message: fileName + " " + this.$t("contract.err_ext"),
            styleType: "danger"
          });
          return;
        }
        if (!this.fileNames.includes(fileName)) {
          this.contract_files.push(uploadedFiles[i]);
          this.fileNames.push(fileName);
        } else {
          fileNameExist += fileName + " ";
        }
      }
      if (fileNameExist != "") {
        this.ON_SHOW_TOAST({
          message: this.$t("contract.file_exist", {
            "0": fileNameExist
          }),
          styleType: "danger"
        });
      } else {
        $(this.$refs["modal-import"]).modal("show");
      }
    },
    validateEmail: function(email) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!pattern.test(email)) {
        email = "";
        return false;
      } else {
        return true;
      }
    },
    waitingLoading: function(bol) {
      this.isLoading = bol;
    },
    showPrintPdf: function() {
      let routeData = this.$router.resolve({
        name: "ResidentOfDocument",
        params: {
          id: this.$route.params.id
        }
      });
      window.open(routeData.href, "_blank");
    },
    getVehicles: function(vehicles) {
      this.vehicles = vehicles;
      this.$emit("vehicles", this.vehicles);
    },
    relativesItems: function(relativesitems) {
      this.relativesitems = relativesitems;
      this.$emit("relatives_items", this.relativesitems);
    },
    relatedResidentsItems: function(relatedresidentsitems) {
      this.relatedresidentsitems = relatedresidentsitems;
      this.$emit("related_residents_items", this.relatedresidentsitems);
    },
    getCards: function(cards) {
      this.cards = cards;
      this.$emit("cards", this.cards);
    },
    showConfirmEmail: function() {
      if (this.newEmail === "" || this.oldEmail === "") {
        let required_title = "user.inform_modal[0].empty_error";
        this.showError(required_title);
      } else if (this.validateEmail(this.newEmail) == false) {
        let email_error = "user.inform_modal[0].email_error";
        this.showError(email_error);
      } else $("#modal-confirm-change-email").modal("show");
    },
    // #615
    onUpdateEmail: function() {
      //   if (
      //     this.newEmail === "" ||
      //     this.oldEmail === ""
      //   ) {
      //     let required_title = "user.inform_modal[0].empty_error";
      //     this.showError(required_title)
      //   } else if (this.validateEmail(this.newEmail) == false) {
      //     let email_error = "user.inform_modal[0].email_error";
      //     this.showError(email_error)
      //   } else {
      $("#modal-confirm-change-email").modal("hide");
      $("#modal-change-email").modal("hide");
      let data = {
        id: this.customerdata.id,
        old_email: this.oldEmail,
        new_email: this.newEmail,
        domain: Enum.domain
      };
      this.UPDATE_CUSTOMER_EMAIL(data)
        .then(
          function() {
            let success_title = this.$t(
              "user.inform_modal[0].email_updated_success",
              { "0": this.oldEmail, "1": this.newEmail }
            );
            this.customerdata.email = this.newEmail;
            this.showSuccess(success_title);
          }.bind(this)
        )
        .catch(
          function(error) {
            let failed_title = "Unknow";
            if (error.response.data.message.includes("email_exist_in_system"))
              failed_title = "user.inform_modal[0].email_exist_in_system";

            this.showError(failed_title);
          }.bind(this)
        );
      //   }
    },
    doResentActivattionAccount() {
      let data = {
        id: this.customerdata.id,
        domain: Enum.domain
      };
      this.RESEND_ACTIVE_EMAIL_CUSTOMER(data)
        .then(
          function() {
            let success_title = this.$t(
              "user.inform_modal[0].re_email_actived"
            );
            this.showSuccess(success_title);
            this.email_activated = true;
            this.status_active = "";
          }.bind(this)
        )
        .catch(
          function(error) {
            let failed_title = "Unknow";
            if (error.response.data.message.includes("email_exist_in_system"))
              failed_title = "user.inform_modal[0].email_exist_in_system";

            this.showError(failed_title);
          }.bind(this)
        );
    },
    doActivateAccount() {
      let data = {
        id: this.customerdata.id
      };
      this.FORCE_ACTIVE_EMAIL_CUSTOMER(data)
        .then(
          function() {
            let success_title = this.$t("user.inform_modal[0].email_actived");
            this.showSuccess(success_title);
            this.email_activated = true;
            this.status_active = "";
          }.bind(this)
        )
        .catch(
          function(error) {
            let failed_title = "Unknow";
            if (error.response.data.message.includes("email_exist_in_system"))
              failed_title = "user.inform_modal[0].email_exist_in_system";

            this.showError(failed_title);
          }.bind(this)
        );
    }
  },
  async mounted() {
    let id = this.$route.params.id;
    this.params_id = id;
    this.GET_REWARD_POINT();
    this.GET_COUNTRY_LIST().then(
      function(res) {
        let countries = [
          {
            value: null,
            text: "---"
          }
        ];
        let data = res.data;
        data.forEach(c => {
          let country = {
            value: c.id,
            text: c.country_name
          };
          countries.push(country);
        });
        this.country_list = countries;
      }.bind(this)
    );
    if (parseInt(id) !== 0) {
      this.customerdata.id = id;
      const contract = {
        params: {
          id: parseInt(id)
        }
      };
      this.pagetitle = "Edit Campaign";
      await this.GET_CUSTOMER_DETAIL({ id: id }).then(
        function(res) {
          const data = {
            params: {
              resident: id
            }
          };
          this.GET_APARTMENT_RESIDENT_SEARCH(data).then(
            function(res) {
              let apartments = [];
              res.forEach(v => {
                let item = v.apartment_to;
                apartments.push(item.apartment_code);
              });
              this.in_charge_of_apartments = apartments.join(", ");
              this.$emit(
                "in_charge_of_apartments",
                this.in_charge_of_apartments
              );
            }.bind(this)
          );
        }.bind(this)
      );
      this.getUserExportInfoList();
      this.assignShow = false;
      this.showPasswordText = false;
      this.show_email = true;
      await this.GET_CUSTOMER_DETAIL({ id: this.params_id }).then(
          function() {
            this.GET_UPLOAD_USER_DATA(contract);
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    } else {
      this.customerdata.password = constantsData.password_default.password;
      this.showPasswordText = true;
      // [loitt] - initialize check is active
      this.email_activated = false;
      this.show_email = false;
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker,
    Avatar,
    loading: Loading,
    // RelativesView,
    // RelatedResidentsView,
    // ResidentCards,
    // RegisterVehicleView,
    RegisterOtherInfoView,
    AddCustomerIntoApartment
  }
};
</script>

<style lang="" scoped>
.inside-section-header {
  border-bottom: 1px solid #eee;
  margin-bottom: 9px;
  margin-top: 9px;
}

@media (min-width: 768px) {
  .modal-dialog {
    width: 800px;
  }
}
.lnu_container {
  display: block;
  margin: 10px auto;
  margin-bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.lnu_container p {
  width: 30%;
  height: auto;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 98, 0.8);
  background: linear-gradient(to right, #06a65a 50%, #eee 50%);
  background-size: 200% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
.got_lowercase,
.got_uppercase,
.got_number {
  background-position: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
}
.show_password_length {
  display: block !important;
  z-index: inherit;
}
.password_length {
  padding: 2px 8px;
  position: absolute;
  top: 42px;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_modal {
  padding: 2px 8px;
  position: absolute;
  top: 38.3%;
  right: 50px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_count {
  background: #06a65a;
  color: rgba(255, 255, 255, 0.9);
}

.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}

.form-group.warning .control-label:after {
  color: #06a65a; /* #ffa500 */
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}
.email_default {
  padding: 2px 8px;
  position: absolute;
  top: 42px;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.show_email {
  display: block !important;
}
.email_activated {
  background: #06a65a;
  color: rgba(255, 255, 255, 0.9);
  font-family: "Glyphicons Halflings";
}
.email_activated::after {
  content: "\E013";
}
.bronzestar {
  font-size: 150px;
  color: #70ad47;
}
.silverstar {
  font-size: 150px;
  color: #b5b5b5;
}
.goldstar {
  font-size: 150px;
  color: #ffc000;
}
.platinumstar {
  font-size: 150px;
  color: #5b9bd5;
}
</style>



// WEBPACK FOOTER //
// src/views/Customer/CustomerAddPersonalV2.vue